import $ from 'jquery'
import Cookies from 'js-cookie';
import {Modal} from 'bootstrap'

document.addEventListener('DOMContentLoaded', function (e) {
    const notification = e.target.querySelector('.part-notification')
    let notificationIsClose = JSON.parse(sessionStorage.getItem('notification-is-close'))
    if (notification) {
        const notificationClose = notification.querySelector(
            '.js-close-notification',
        )
        if (notificationClose) {
            if (notificationIsClose) {
                notification.style.display = 'none'
            }
            notificationClose.addEventListener('click', function (e) {
                sessionStorage.setItem('notification-is-close', 'true')
                notification.style.display = 'none'
                notificationIsClose = true
            })
        }
    }


    const modalElement = document.getElementById('adsModal');
    if (modalElement) {
        const adsModal = new Modal(modalElement);
        let popupIsClose = JSON.parse(sessionStorage.getItem('popup-is-close'))
        if (!popupIsClose) {
            setTimeout(() => {
                adsModal.show();
            }, 3000);
        }
        $('#adsModal').on('hidden.bs.modal', function (e) {
            sessionStorage.setItem('popup-is-close', 'true')
            popupIsClose = true
        })
    }
})
